import ThemeRadii from '../ThemeRadii';
import { RadiiArray } from '../types';

export default (radiiValues: RadiiArray, namedValues: Record<ThemeRadii, number>) => {
  return {
    ...radiiValues,
    ...namedValues,
  };
};
